import { useIsLoggedOn } from "../../stores/hooks/useIsLoggedOn";
import { useNullableDealerAccountInfo } from "../../stores/hooks/useNullableDealerAccountInfo";

export const useStockIsEnabled = (): boolean => {
  const isLoggedOn = useIsLoggedOn();
  const dealer = useNullableDealerAccountInfo();

  // const {
  //   supportConsumerOrder,
  //   supportDealerOrder,
  //   supportUserConsumerOrder,
  //   supportUserDealerOrder,
  // } = dealer;

  // return supportConsumerOrder || (isLoggedOn && supportDealerOrder);
  return isLoggedOn || Boolean(dealer?.dealerEnableStockForCustomers);
};
